import { ValidationRules } from "@/models/Validation";
import { formatDateISO } from "@/utils/formatDates";
import dayjs from "dayjs";
import { t } from "@/plugins/i18n";

export class CurrencyRate {
  rateDate = dayjs().format("YYYY-MM-DD");
  centralRate = 1;
  mnbCentralRate = 1;
  currency = "HUF";
  localCurrency = "HUF";
  unit = 1;

  constructor(params?: Partial<CurrencyRate>) {
    const data = { ...params };
    Object.assign(this, data);
  }
}

export const rules: ValidationRules = {
  currency: [
    (v: string) => !!v || t("CurrencyRate_PenznemMegadasaKozelezo"),
    (v: string) => !(parseFloat(v) >= 0) || t("CurrencyRate_PenznemNemTartalmazhatSzamot"),
  ],
  centralRate: [
    (v: number) => !!v || t("CurrencyRate_KozeparfolyamMegadasaKozelezo"),
    (v: number) => v.valueOf() > 0 || t("CurrencyRate_KozeparfolyamNemLehetNullaVagyAlatti"),
  ],
  rateDate: [
    (v: number) => !!v || t("CurrencyRate_DatumMegadasaKotelezo"),
    (v: Date | string) => new Date(v) < new Date() || t("CurrencyRate_JovobeliDatumotNemLehetMegadni"),
  ],
  unit: [
    (v: number) => !!v || t("CurrencyRate_EgysegMegadasaKozelezo"),
    (v: number) => v > 0 || t("CurrencyRate_EgysegNemLehetNullaVagyAlatti"),
  ],
};

export const currencyRateDefaultProps: CurrencyRate = {
  rateDate: formatDateISO(new Date()),
  centralRate: 0,
  mnbCentralRate: 1,
  currency: "HUF",
  localCurrency: "",
  unit: 1,
};
